import React from 'react';
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';

interface SellerRouteProps extends Omit<RouteProps, 'component'> {
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}

/**
 * Route component that ensures only Seller or Admin users can access the wrapped component
 * Leverages the ProtectedRoute component for authentication checking
 */
export const SellerRoute: React.FC<SellerRouteProps> = ({
  component: Component,
  ...rest
}) => {
  // Only log in development mode
  if (process.env.NODE_ENV === 'development') {
    console.log(`SellerRoute: ${rest.path}`);
  }

  return (
    <Route
      {...rest}
      render={(props) => {

        return (
          <ProtectedRoute roles={['seller', 'Seller', 'Admin']}>
            <Component {...props} />
          </ProtectedRoute>
        );
      }}
    />
  );
};